import React, { useState } from "react";

import SARefundRequest from "./SARefundRequest";
import SARefundRequestDenied from "./SARefundRequestDenied";
import SARefundedDone from "./SARefundedDone";

const SuperRefunds = () => {
   
  const [activeTab, setActiveTab] = useState(1); // Set the default active tab to 2 (Tab 2)

  // Function to handle tab click
  const handleTabClick = (tabIndex) => {
      setActiveTab(tabIndex);
  };

  return (
    <div>
      <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
        <h2 className='headingTxt'>SuperRefunds</h2>
      </div>
      <div className='px-5 mt-5'>
                <div className='grid grid-cols-4 gap-5 py-2 w-[600px]'>
                    <button onClick={() => handleTabClick(1)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Refund Request</button>
                    <button onClick={() => handleTabClick(2)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Refunded</button>
                    <button onClick={() => handleTabClick(3)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Request Denied</button>

           </div>
                {/* Content for Tab 1 */}
                {activeTab === 1 && (
                    <div className="tab-content w-full">
                        <SARefundRequest></SARefundRequest>
                    </div>
                )}

                {/* Content for Tab 2 */}
                {activeTab === 2 && (
                    <div className='tab-content w-full'>
                      <SARefundedDone></SARefundedDone>
                    </div>
                )}
                {/* Content for Tab 3 */}
                {activeTab === 3 && (
                    <div className='tab-content w-full'>
                       <SARefundRequestDenied></SARefundRequestDenied>
                    </div>
                )}
                {/* Content for Tab 4 */}
  

            </div>
    </div>
  );
};

export default SuperRefunds;
